{
  "id": "school-overview",
  "slug": "school-overview",
  "title": "What to Know About {school}",
  "taskType": "anytime",
  "preview": "Review important policies and expectations",
  "description": "Here's everything you need to know to get off to a great start at {school}, from what to expect during the first week, to what your school will expect of you.",
  "displayConditions": {
    "userRole": [],
    "gradeBand": []
  },
  "content": [],
  "subtasks": [],
  "keepLearning": [],
  "featured": false,
  "availableDaysBefore": null,
  "dueDaysBefore": null,
  "wpSections": [
    {
      "id": "quick-links",
      "title": "Quick Links",
      "fields": [
        {
          "key": "calendar_link",
          "label": "{schoolAbbr} Academic Calendar",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null
      }
    },
    {
      "id": "first-week",
      "title": "{student}'s First Week",
      "fields": [
        {
          "key": "first_week_description",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        },
        {
          "key": "student_orientation_live",
          "kind": "body",
          "label": "Student Orientation",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        },
        {
          "key": "student_orientation_recorded",
          "kind": "body",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        },
        {
          "key": "learning_coach_orientation",
          "kind": "body",
          "label": "Learning Coach Orientation",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [
              "learningCoach"
            ],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        },
        {
          "key": "meet_the_teacher_event",
          "kind": "body",
          "label": "Meet the Teacher",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        },
        {
          "key": "standardized_testing_requirements",
          "kind": "body",
          "label": "Beginning-of-Year Assessments",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null
      }
    },
    {
      "id": "class-schedule",
      "title": "Accessing {student}'s Class Schedule",
      "fields": [
        {
          "key": "class_schedule_instructions",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null
      }
    },
    {
      "id": "general-expectations",
      "title": "General School Expectations",
      "fields": [
        {
          "key": "general_school_expectations",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        },
        {
          "key": "attendance_content_standard",
          "label": "Attendance",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [
              "standard"
            ],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        },
        {
          "key": "attendance_content_flex",
          "label": "Attendance",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [
              "flex"
            ],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        },
        {
          "key": "homework",
          "label": "Homework",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        },
        {
          "key": "quizzes_and_tests",
          "label": "Quizzes & Tests",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        },
        {
          "key": "quizzes_and_tests_learning_coach",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [
              "learningCoach"
            ],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null
      }
    },
    {
      "id": "",
      "title": "About the Standard Program",
      "fields": [
        {
          "key": "flex_program_not_enrolled",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [
          "standard"
        ],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null
      }
    },
    {
      "id": "",
      "title": "About the Flex Program",
      "fields": [
        {
          "key": "flex_program_enrolled",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [
          "flex"
        ],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null
      }
    },
    {
      "id": "testing",
      "title": "In-Person Requirements for Standardized State Testing ",
      "fields": [
        {
          "key": "standardized_testing",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null
      }
    },
    {
      "id": "clubs-workshops",
      "title": "Clubs & Workshops",
      "fields": [
        {
          "key": "clubs_workshops_description",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        },
        {
          "key": "clubs_workshops_link",
          "label": "Explore Clubs and Activities",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null,
        "launchpadAvailable": null
      }
    },
    {
      "id": "faq",
      "title": "Frequently Asked Questions",
      "fields": [
        {
          "key": "iep",
          "label": "My child needs special education services (IEP/504). When will I get to discuss their needs?",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [
              "learningCoach"
            ],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        },
        {
          "key": "login_information",
          "label": "What do I do if I forget my login information? ",
          "displayConditions": {
            "ageRange": {
              "max": null,
              "min": null
            },
            "userRole": [],
            "gradeBand": [],
            "schoolType": [],
            "programType": [],
            "olsAvailable": null,
            "coursesAssigned": null,
            "schoolOffersFlex": null,
            "launchpadAvailable": null
          }
        }
      ],
      "displayConditions": {
        "ageRange": {
          "max": null,
          "min": null
        },
        "userRole": [],
        "gradeBand": [],
        "schoolType": [],
        "programType": [],
        "olsAvailable": null,
        "coursesAssigned": null,
        "schoolOffersFlex": null,
        "launchpadAvailable": null
      }
    }
  ],
  "wpFaq": {
    "calloutMarkdown": "**Come Back Again Soon**\n\n{schoolAbbr} is in the process of preparing new information for the beginning of the school year—come back closer to the start of the year to learn more. \n\nIn the meantime, here are answers to some common questions you might have."
  }
}